import LockLabel from './LockLabel';

export default LockLabel;
